<div class="target-items">
  <div class="target-items__header">
    <div class="target-items__title">
      <svg-icon
        class="flex items-center justify-center s-18 icon-yellow"
        src="assets/icons/updater/upgrade-items.svg"
        [applyClass]="true"
      />
      <span>Upgrade Items</span>
    </div>

    @if (sessionService.balanceType() === 'pure') {
      <div class="target-items__header-actions">
        <app-checkbox
          [(checked)]="showPureSkins"
          (checkedChange)="onPureToggle($event)"
          [disabled]="upgraderService.state() !== 'idle'"
        >
          <span class="target-items__checkbox-label">Show Pure Skins</span>
        </app-checkbox>
      </div>
    }
  </div>

  <div class="target-items__controls">
    <app-search-input
      [query]="search()"
      (queryChange)="onSearchChange($event)"
      [disabled]="isLoading() || upgraderService.isProcessing()"
    />
    <div class="target-items__actions">
      <button
        class="button button--style-secondary target-items__refresh-btn"
        (click)="refreshItems()"
        [disabled]="isLoading() || upgraderService.isProcessing()"
      >
        <svg-icon
          class="flex items-center justify-center s-14 icon-gray"
          src="assets/icons/ui/refresh.svg"
          [applyClass]="true"
          [@rotateRefreshAnimation]="isRefreshing() ? 'active' : 'inactive'"
        />
        Refresh
      </button>

      <app-toggle
        [title]="'Sort by'"
        [value]="currentSort().label"
        (handleClick)="toggleSort()"
        [arrowPosition]="currentSort().key === 'highest_price' ? 'top' : 'down'"
        [disabled]="isLoading() || upgraderService.isProcessing()"
      />
    </div>
  </div>

  <div class="target-items__content" [class.target-items__content--disabled]="isSelectionDisabled()">
    @if (isLoading()) {
      <div class="target-items__state target-items__state--loading">
        <app-loading-icon color="var(--yellow)" size="48px"/>
      </div>
    } @else if (error()) {
      <div class="target-items__state target-items__state--error">
        <p>{{ error() }}</p>
        <button
          class="button button--style-primary"
          (click)="refreshItems()"
        >
          Retry
        </button>
      </div>
    } @else if (displayedSkins().length === 0 && search()) {
      <div class="target-items__state target-items__state--empty">
        <p>No items found matching "{{ search() }}"</p>
        <button
          class="button button--style-yellow"
          (click)="search.set('')"
        >
          Clear search
        </button>
      </div>
    } @else if (displayedSkins().length === 0) {
      <div class="target-items__state target-items__state--empty">
        <p>No items available</p>
        <button
          class="button button--style-primary"
          (click)="refreshItems()"
        >
          Refresh
        </button>
      </div>
    } @else {
      <app-skins-list
        class="target-items__grid"
        [skins]="paginatedSkins()"
        [config]="gridConfig()"
        [(selectedSkins)]="upgraderService.selectedTargetSkins"
        [selectable]="!isSelectionDisabled()"
        [balanceType]="'skins'"
      />
    }

    @if (totalPages() > 1) {
      <app-table-pagination
        class="target-items__pagination"
        [currentPage]="pageIndex() + 1"
        [pageCount]="totalPages()"
        [disabledPreviousPage]="pageIndex() === 0"
        [disabledNextPage]="pageIndex() >= totalPages() - 1"
        [showFirstPage]="false"
        [showLastPage]="false"
        (handlePreviousPage)="prevPage()"
        (handleNextPage)="nextPage()"
      />
    }
  </div>
</div>
